/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateProjectBudgetInput = {|
  projects?: ?$ReadOnlyArray<?ProjectInputType>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ProjectInputType = {|
  id?: ?number,
  budgetBaseCurrency?: ?number,
  projectProgramBudgetType?: ?string,
|};
export type updateProjectBudgetMutationVariables = {|
  input: UpdateProjectBudgetInput
|};
export type updateProjectBudgetMutationResponse = {|
  +updateProjectBudget: ?{|
    +clientMutationId: ?string
  |}
|};
export type updateProjectBudgetMutation = {|
  variables: updateProjectBudgetMutationVariables,
  response: updateProjectBudgetMutationResponse,
|};
*/


/*
mutation updateProjectBudgetMutation(
  $input: UpdateProjectBudgetInput!
) {
  updateProjectBudget(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectBudgetInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateProjectBudgetPayload",
    "kind": "LinkedField",
    "name": "updateProjectBudget",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectBudgetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectBudgetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateProjectBudgetMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectBudgetMutation(\n  $input: UpdateProjectBudgetInput!\n) {\n  updateProjectBudget(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6faf650bd58c5a049951a974d8e2c4b6';

module.exports = node;
